import { Grid, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import Money from 'modules/Referral/PayoutProfiles/Invoices/subcomponents/Money'
import StatusIcon from 'modules/Referral/PayoutProfiles/Invoices/subcomponents/StatusIcon'
import styles from 'modules/Referral/PayoutProfiles/Invoices/subcomponents/Row/payouts-list-item.module.scss'
import { useTranslation } from 'react-i18next'

export const Row = ({
  id,
  requested_amount = { value: 0, currency: 'RUB' },
  payout_amount = { value: 0, currency: 'RUB' },
  status = '',
}) => {
  const { t } = useTranslation()
  const breakpoints = useBreakpoint()

  return (
    <Grid className={styles['payouts-list__row']} justifyContent={'stretch'}>
      <Grid direction={'row'} wrap={false} gap={16} alignItems={'center'}>
        <StatusIcon status={status} breakpoints={breakpoints} />
        <Grid direction={'column'} gap={2} justifyContent={'center'}>
          <Typography variant="Body-Forms-15" color={'Label-Fifth'}>
            {t(`referral::payouts_invoices.invoice_id`)}: {id}
          </Typography>
          <Typography variant={'Body-10'} color={'Label-Secondary'}>
            {t(
              `referral::payouts_invoices.filters.dropdown.items.statuses.options.${status}`,
            )}
          </Typography>
          {!breakpoints.md && (
            <Typography
              noWrap={true}
              variant={'Body-5'}
              color={'Label-Secondary'}
              component={'span'}
            >
              {t('referral::payouts_invoices.requested_amount')}
              {': '}
              <Money
                number={requested_amount.value}
                currency={requested_amount.currency}
              />
            </Typography>
          )}
        </Grid>
      </Grid>

      <Grid
        direction={'column'}
        gap={8}
        alignItems={'flex-end'}
        justifyContent={'center'}
      >
        <Typography
          variant={'Body-25'}
          color={'Label-Fifth'}
          component={'span'}
        >
          <Money
            number={payout_amount.value}
            currency={payout_amount.currency}
          />
        </Typography>

        {breakpoints.md && (
          <Typography
            variant={'Body-15'}
            color={'Label-Secondary'}
            component={'span'}
          >
            {t('referral::payouts_invoices.requested_amount')}
            {': '}
            <Money
              number={requested_amount.value}
              currency={requested_amount.currency}
            />
          </Typography>
        )}
      </Grid>
    </Grid>
  )
}

Row.propTypes = {
  payout_amount: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number]),
    currency: PropTypes.oneOf(['RUB', 'USD', 'EUR']),
  }),
  requested_amount: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number]),
    currency: PropTypes.oneOf(['RUB', 'USD', 'EUR']),
  }),
  id: PropTypes.number,
  status: PropTypes.oneOf([
    'new',
    'pending',
    'declined',
    'handled',
    'blocked',
    'cancelled',
  ]),
}

export default Row
